import React, { useEffect, useState,useRef } from 'react';
import axios from 'axios';
import { Col, Row,Table } from 'react-bootstrap';
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";

const UserLogs = () => {
 const [deposits, setDeposits] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const componentRef = useRef()
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Userdata",
   });
   const [showUnpaidOnly, setShowUnpaidOnly] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      // Replace with your API endpoint and parameters for date filtering
      const response = await axios.get('https://suhba.education.com.ly/back/api/prepaybydelivery', {
        params: {
          date_from: dateFrom,
          date_to: dateTo,
          
        },
      });
      
      setDeposits(response.data.data);
      setTotalAmount(response.data.total);
    } catch (error) {
      console.error('Error fetching deposits:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
 if (dateTo || dateFrom  ) {
      fetchData();
    }

   }, [dateTo,dateFrom]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData();
  };
const topRef = useRef(null);    // لنهاية التقرير
const bottomRef = useRef(null); // لبداية التقرير
const scrollToTop = () => {
  topRef.current?.scrollIntoView({ behavior: 'smooth' });
};

const scrollToBottom = () => {
  bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
};
  return (
//    <div className="container-fluid   p-4" >
//         <Row>
//           <Col lg="12">
//           <div className="card">

//               <div className="card-header" >
//                 <h4 className="heading mb-0">عرابين الطلبيات</h4>
//                  <div>
//                                   <Link                     onClick={generatePDF}
//                  to="#" className="btn btn-secondary btn-sm ms-1" data-bs-toggle="offcanvas">
//                                     <i className="fa-solid fa-print ms-1" /> طباعه
//                                   </Link>
                
//                                 </div>
//                 </div>
//  <div className="col-xl-12">
//   <div className="row g-2 align-items-center flex-nowrap m-3">
//     <div className="d-flex align-items-center flex-nowrap w-100">
//       {/* Form Elements */}
//          {/* Label */}
//         <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>
//           تواريخ استلام الطلبيات :
//         </label>

//         {/* From Date */}
//         <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>من تاريخ:</label>
//         <input
//           type="date"
//           className="form-control me-2"
//           style={{ minWidth: "140px" }}
//           value={dateFrom}
//           onChange={(e) => setDateFrom(e.target.value)}
//         />

//         {/* To Date */}
//         <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>إلى تاريخ:</label>
//         <input
//           type="date"
//           className="form-control me-2"
//           style={{ minWidth: "140px" }}
//           value={dateTo}
//           onChange={(e) => setDateTo(e.target.value)}
//         />

//         {/* Search Button */}
 
//       {/* Clear Button */}
//       <button
//         className="btn btn-danger btn-sm me-2"
//         onClick={() => {
//           setDateFrom("");
//           setDateTo("");
//           setDeposits([]);
//         }}
//       >
//         إلغاء 
//       </button>
//     </div>
//   </div>
// </div>




//       {loading ? (
//         <p>جاري التحميل...</p>
//       ) : (
// <div className="table-responsive table-bordered m-3 print-area" style={{ overflowX: 'auto', maxHeight: '400px' }} >
//        <div ref={componentRef}> 
//           <div
//   className="m-3 p-3 border rounded-3 shadow-sm text-center"
//   dir="rtl"
//   style={{
//     backgroundColor: 'rgba(240, 240, 255, 0.8)',
//     border: '1px solid #ccc'
//   }}
// >
//   <h3 style={{ color: 'navy', fontWeight: 'bold', marginBottom: '10px' }}>
//     تقرير العربون للطلبيات
//   </h3>

//   <p style={{ fontSize: '16px', margin: '0' }}>
//     هذا التقرير يعرض تفاصيل العربون لجميع الطلبيات
//     <br />
//     خلال الفترة من
//     <strong style={{ color: 'green', margin: '0 5px' }}>{dateFrom}</strong>
//     إلى
//     <strong style={{ color: 'green', margin: '0 5px' }}>{dateTo}</strong>
//   </p>

//   <p style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px' }}>
//     إجمالي قيمة العربون خلال هذه الفترة:
//     <span style={{ color: 'blue', marginRight: '8px' }}>
//       {totalAmount.toLocaleString()} د.ل
//     </span>
//   </p>
 
//         <table className="table table-bordered text-center" dir="rtl" style={{ width: '100%', borderCollapse: 'collapse' }}>
//   <thead style={{ position: 'sticky', top: 0, backgroundColor: 'rgba(189, 173, 235, 1)', zIndex: 2 ,color: 'black'}}>            <tr>
//                <th>قيمة العربون</th>
//               <th>تاريخ الإيداع</th>
//                <th>اسم الزبون</th>
//               <th>تاريخ التسليم</th>
//             </tr>
//           </thead>
//           <tbody>
//             {deposits.length > 0 ? (
//               deposits.map((row) => (
//                 <tr key={row.id}>
//                    <td>{row.amount.toLocaleString()}</td>
//                   <td>{row.deposit_date}</td>
//                    <td>{row.CustomerName}</td>
//                   <td>{row.DeliveryDate}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="7" style={{ color: 'red', fontWeight: 'bold' }}>
//                   لا توجد بيانات للعرض
//                 </td>
//               </tr>
//             )}
//           </tbody>
         
//         </table>
        
//            {deposits.length > 0 && (
//   <div
//   style={{
//     fontWeight: 'bold',
//     fontSize: '18px',
//     direction: 'rtl',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     margin: '10px'
//   }}
// >
//   <label
//     htmlFor="startMonth"
//     style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue', margin: 0 }}
//   >
//     اجمالي دخل العرابين لهده الطلبيات :
//   </label>

//   <div style={{ color: 'green' }}>
//     <strong>{totalAmount.toLocaleString()} د.ل</strong>
//   </div>
// </div>

// )}
    
//    </div> </div>
//          </div>
//       )} 
//           </div>

//      </Col></Row>
//     </div>
    <div className="container-fluid p-4">
  <Row>
    <Col lg="12">
      <div className="card">
        <div className="card-header">
          <h4 className="heading mb-0">عرابين الطلبيات</h4>
          <div>
            <Link
              onClick={generatePDF}
              to="#"
              className="btn btn-secondary btn-sm ms-1"
              data-bs-toggle="offcanvas"
            >
              <i className="fa-solid fa-print ms-1" /> طباعه
            </Link>
          </div>
        </div>

        {/* تواريخ البحث */}
        <div className="col-xl-12">
          <row>
          <div className="row g-2 align-items-center flex-nowrap m-3">
            <div className="d-flex align-items-center flex-nowrap w-100">
              <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>
                تواريخ استلام الطلبيات :
              </label>
              <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>من تاريخ:</label>
              <input
                type="date"
                className="form-control me-2"
                style={{ minWidth: "140px" }}
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
              <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>إلى تاريخ:</label>
              <input
                type="date"
                className="form-control me-2"
                style={{ minWidth: "140px" }}
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />

              {/* زر الإلغاء */}
              <button
                className="btn btn-danger btn-sm me-2"
                onClick={() => {
                  setDateFrom("");
                  setDateTo("");
                  setDeposits([]);
                }}
              >
                إلغاء
              </button>

              {/* فلتر حالة الدفع */}
             
            </div>
          </div></row>
          <row>
             <label className="form-label mb-0 mx-3">
                <input
                  type="checkbox"
                  checked={showUnpaidOnly}
                  onChange={(e) => setShowUnpaidOnly(e.target.checked)}
                  className="me-1"
                />
                عرض فقط العملاء الذين لم يدفعوا الباقي
              </label>
          </row>
        </div>

        {loading ? (
          <p>جاري التحميل...</p>
        ) : (
          <div className="table-responsive table-bordered m-3 print-area" style={{ overflowX: 'auto', maxHeight: '400px' }}>
         
            <div ref={componentRef}>
              <div
                className="m-3 p-3 border rounded-3 shadow-sm text-center"
                dir="rtl"
                style={{
                  backgroundColor: 'rgba(240, 240, 255, 0.8)',
                  border: '1px solid #ccc'
                }}
              >
                <h3 style={{ color: 'navy', fontWeight: 'bold', marginBottom: '10px' }}>
                  تقرير العربون للطلبيات
                </h3>

                <p style={{ fontSize: '16px', margin: '0' }}>
                  هذا التقرير يعرض تفاصيل العربون لجميع الطلبيات
                  <br />
                  خلال الفترة من
                  <strong style={{ color: 'green', margin: '0 5px' }}>{dateFrom}</strong>
                  إلى
                  <strong style={{ color: 'green', margin: '0 5px' }}>{dateTo}</strong>
                </p>

                <p style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px' }}>
                  إجمالي قيمة العربون خلال هذه الفترة:
                  <span style={{ color: 'blue', marginRight: '8px' }}>
                    {totalAmount.toLocaleString()} د.ل
                  </span>
                </p>

                {/* جدول العربون */}
                <table className="table table-bordered text-center" dir="rtl" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead style={{ position: 'sticky', top: 0, backgroundColor: 'rgba(189, 173, 235, 1)', zIndex: 2, color: 'black' }}>
                    <tr>
                     <th>
  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-start' }}>
    <span>قيمة العربون</span>
 <i class="fas fa-arrow-circle-down" onClick={scrollToBottom}></i>    
    <i class="fas fa-arrow-circle-up"onClick={scrollToTop}></i>
  </div>
</th>
                      <th>تاريخ الإيداع</th>
                      <th>اسم الزبون</th>
                      <th>تاريخ التسليم</th>
                      <th>حالة الدفع</th> {/* الجديد */}
                      <th>باقي القيمة</th>
                    </tr>
                  </thead>
                  <tbody>
                    <div ref={topRef}></div>
                    {deposits.length > 0 ? (
                      deposits
                        .filter(row => !showUnpaidOnly || row.payment_status === 'لم يتم دفع الباقي')
                        .map((row) => (
                          <tr key={row.id}>
                            <td>{row.amount.toLocaleString()}</td>
                            <td>{row.deposit_date}</td>
                            <td>{row.CustomerName}</td>
                            <td>{row.DeliveryDate}</td>
                            <td>{row.payment_status}</td> {/* الجديد */}
                            <td style={{ color: 'red', fontWeight: 'bold' }}>
  {Number(row.remaining_amount).toLocaleString()} د.ل
</td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="8" style={{ color: 'red', fontWeight: 'bold' }}>
                          لا توجد بيانات للعرض
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* إجمالي العربون مع الفلتر */}
                {deposits.length > 0 && (
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: '18px',
                      direction: 'rtl',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      margin: '10px'
                    }}
                  >
                    <label
                      htmlFor="startMonth"
                      style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue', margin: 0 }}
                    >
                      اجمالي دخل العرابين لهده الطلبيات :
                    </label>

                    <div style={{ color: 'green' }}>
                      <strong>
                        {deposits
  .filter(row => !showUnpaidOnly || row.payment_status === 'لم يتم دفع الباقي')
  .reduce((sum, row) => sum + Number(row.amount), 0)
  .toLocaleString()} د.ل
                      </strong>
                    </div>
                    <div ref={bottomRef}></div>
                  </div>
                )}

              </div>
            </div>
          </div>
        )}
      </div>
    </Col>
  </Row>
</div>
  );
};

export default UserLogs;
